import React, { Fragment,useEffect } from "react";
import "../../styles/auth.css";
import { Outlet } from "react-router-dom";

const Layout = () => {

  useEffect(() => {
    document.title = "MedRecAps: Authentication"
 }, []);
  return (
    <Fragment>
      <div className="auth px-2">
        <section className="">
         
                <Outlet/>
              
        </section>
      </div>
    </Fragment>
  );
};

export default Layout;
